import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { getPrintedTicket } from '../../../../../actions/index';
import PostponeTicketButton from './PostponeTicketButton';
import PassengerChangeButton from './PassengerChangeButton';
import SendTicketButton from './SendTicketButton';
import VoucherTypeChangeButton from './../ticket-toolbar/VoucherTypeChangeButton';
import RefundButton from './RefundButton';
import {
  PIN_PAD_TRANSACTION_SOURCE_TYPE,
  TICKET_STATUS,
} from '../../../../../config/constants';
import PinPadVoucherButtons from '../../../../common/button/PinPadVoucherButtons';
import PrintTicketButton from './PrintTicketButton';
import VoidTicketButton from './VoidTicketButton';
import PrintCreditNoteButton from './PrintCreditNoteButton';
import EditAcountingDataButton from './EditAcountingDataButton';
import CustomerUpdateHistoryChangeButton from './CustomerUpdateHistoryChangeButton';
import ChangeLocationButton from './ChangeLocationButton';

const TicketToolbar = ({
  ticketStatus,
  ticketId,
  creditNote,
  departureDate,
  voucherTypeId,
  forThirdParty,
  ticket,
  user: { salesSessionUserId },
  availableCustomerUpdateHistory,
  disabledButtons,
  showPinPadVoucherButtons,
}) => {
  const customerOrderId = ticket ? ticket.get('customerOrderId') : null;

  const pinPadVoucherButtons =
    showPinPadVoucherButtons && customerOrderId ? (
      <PinPadVoucherButtons
        sourceType={PIN_PAD_TRANSACTION_SOURCE_TYPE.TICKET}
        sourceId={customerOrderId}
      />
    ) : null;

  let content = pinPadVoucherButtons && (
    <ButtonToolbar className="pull-right">
      <div>{pinPadVoucherButtons}</div>
    </ButtonToolbar>
  );

  if (ticketStatus === TICKET_STATUS.ACTIVE.value) {
    content = (
      <ButtonToolbar className="pull-right">
        <div>
          <CustomerUpdateHistoryChangeButton
            ticketId={ticketId}
            availableCustomerUpdateHistory={availableCustomerUpdateHistory}
            disabled={disabledButtons}
          />{' '}
          <PassengerChangeButton
            ticketId={ticketId}
            disabled={disabledButtons}
          />{' '}
          {ticket && ticket.get('seatReservation') && (
            <ChangeLocationButton
              ticket={ticket}
              forThirdParty={forThirdParty}
              disabled={disabledButtons}
            />
          )}{' '}
          <PostponeTicketButton
            ticketId={ticketId}
            forThirdParty={forThirdParty}
            ticket={ticket.toJS()}
          />{' '}
          <VoucherTypeChangeButton
            ticketId={ticketId}
            voucherTypeId={voucherTypeId}
            departureDate={departureDate}
          />{' '}
          <SendTicketButton ticketId={ticketId} />{' '}
          <EditAcountingDataButton
            ticket={ticket.toJS()}
            disabled={disabledButtons}
          />{' '}
          <RefundButton
            ticketId={ticketId}
            status={ticketStatus}
            ticketSalePrice={ticket.toJS().salePrice}
            forThirdParty={forThirdParty}
          />{' '}
          <PrintTicketButton
            ticket={ticket}
            salesSessionUserId={salesSessionUserId}
          />{' '}
          <VoidTicketButton
            ticketId={ticketId}
            customerOrderId={ticket.get('customerOrderId')}
            email={ticket.get('customer').email}
            disabled={disabledButtons}
          />{' '}
          {pinPadVoucherButtons}
        </div>
      </ButtonToolbar>
    );
  }

  if (creditNote) {
    const ticketJson = ticket.toJS();

    let totalFromList = 0;

    if (ticketJson.creditNoteList && ticketJson.creditNoteList.length > 0) {
      totalFromList = ticketJson.creditNoteList.reduce((acc, cn) => {
        let amount = 0;

        if (cn.originalAmount != null) {
          amount = cn.originalAmount;
        } else if (cn.amount != null) {
          // eslint-disable-next-line prefer-destructuring
          amount = cn.amount;
        }

        return acc + amount;
      }, 0);
    }

    const isEqual = totalFromList === ticketJson.creditNoteTotalAmount;

    const isValidToRefundPostponed =
      ticketStatus === TICKET_STATUS.POSTPONED.value && isEqual;

    const refundButton = creditNote.valid &&
      (ticketStatus === TICKET_STATUS.ACTIVE.value ||
        isValidToRefundPostponed) && (
        <Fragment>
          {' '}
          <RefundButton
            ticketId={ticketId}
            ticketSalePrice={ticket.toJS().salePrice}
            departureDate={departureDate}
            status={ticketStatus}
          />
        </Fragment>
      );

    const showPrintTicket = ticket && ticket.get('seatReservation') && (
      <Fragment>
        {' '}
        <CustomerUpdateHistoryChangeButton
          ticketId={ticketId}
          availableCustomerUpdateHistory={availableCustomerUpdateHistory}
          disabled={disabledButtons}
        />{' '}
        <PrintTicketButton
          ticket={ticket}
          salesSessionUserId={salesSessionUserId}
        />{' '}
        <PassengerChangeButton ticketId={ticketId} disabled={disabledButtons} />{' '}
        {ticket && ticket.get('seatReservation') && (
          <ChangeLocationButton
            ticket={ticket}
            forThirdParty={forThirdParty}
            disabled={disabledButtons}
          />
        )}{' '}
        <PostponeTicketButton
          ticketId={ticketId}
          forThirdParty={forThirdParty}
          ticket={ticket.toJS()}
          disabled={disabledButtons}
        />{' '}
        <VoucherTypeChangeButton
          ticketId={ticketId}
          voucherTypeId={voucherTypeId}
          departureDate={departureDate}
        />{' '}
        <SendTicketButton ticket Id={ticketId} />{' '}
        <EditAcountingDataButton
          ticket={ticket.toJS()}
          disabled={disabledButtons}
        />{' '}
        <VoidTicketButton
          ticketId={ticketId}
          customerOrderId={ticket.get('customerOrderId')}
          email={ticket.get('customer').email}
          disabled={disabledButtons}
        />
      </Fragment>
    );

    content = (
      <ButtonToolbar className="pull-right">
        <div>
          {showPrintTicket}
          {refundButton}{' '}
          <PrintCreditNoteButton ticket={ticket} disabled={disabledButtons} />{' '}
          {pinPadVoucherButtons}
        </div>
      </ButtonToolbar>
    );
  }

  return content;
};

TicketToolbar.propTypes = {
  ticketId: PropTypes.number.isRequired,
  ticketStatus: PropTypes.string.isRequired,
  ticket: PropTypes.instanceOf(Map),
  departureDate: PropTypes.number,
  voucherTypeId: PropTypes.number.isRequired,
  forThirdParty: PropTypes.bool,
  creditNote: PropTypes.shape({
    reference: PropTypes.string,
    amount: PropTypes.number,
    valid: PropTypes.bool,
  }),
  user: PropTypes.shape({
    salesSessionUserId: PropTypes.number,
  }).isRequired,
  availableCustomerUpdateHistory: PropTypes.bool,
  disabledButtons: PropTypes.bool,
  showPinPadVoucherButtons: PropTypes.bool,
};

TicketToolbar.defaultProps = {
  departureDate: null,
  ticket: null,
  forThirdParty: false,
  creditNote: null,
  availableCustomerUpdateHistory: false,
  disabledButtons: false,
  showPinPadVoucherButtons: false,
};

const mapStateToProps = (state, { ticket }) => {
  const customers = state.UserUnit.Customer.getIn([
    'all',
    'content',
    'content',
  ]).map((customer) => ({
    value: customer.id,
    label: `${customer.idDocumentNumber} - ${customer.fullName}`,
  }));

  const isCustomerLoading = state.UserUnit.Customer.getIn(['all', 'content']);

  const loadingPassengerChange = state.ReservationUnit.Ticket.getIn([
    'current',
    'changingPassenger',
  ]);

  const newTicket =
    ticket || state.ReservationUnit.Ticket.getIn(['current', 'content']);

  return {
    customers,
    isCustomerLoading,
    loadingPassengerChange,
    ticket: newTicket,
    user: state.authentication.get('user'),
  };
};

const mapDispatchToProps = { getPrintedTicket };

export default connect(mapStateToProps, mapDispatchToProps)(TicketToolbar);
